import { Button } from 'antd';
import { setNestedObjectValues, useFormikContext } from 'formik';
import { useCallback, useContext, useMemo } from 'react';

import './CustomerLeadStepLayoutNextButton.scss';

import { isCustomerStepSubmitted } from 'src/helpers/isCustomerStepSubmitted';
import { CustomersContext } from 'src/pages/CustomersPage/CustomersPage.context';

export function CustomerLeadStepLayoutNextButton() {
  const { customerStepsInfo, customerLeadProduct, goNextStep, isLastCustomerStep } = useContext(CustomersContext);

  const { isSubmitting, validateForm, submitForm, setTouched } = useFormikContext<unknown>();

  const isCompleted = useMemo(
    () =>
      customerStepsInfo.every((customerStepInfo) =>
        isCustomerStepSubmitted(customerStepInfo.step, customerLeadProduct)
      ),
    [customerStepsInfo, customerLeadProduct]
  );

  const handleClick = useCallback(async () => {
    const errors = await validateForm();

    if (Object.keys(errors).length === 0) {
      // Use `status`?
      const isGoToNextStep = (await submitForm()) as unknown as boolean;

      if (isGoToNextStep) {
        goNextStep();
      }
    } else {
      await setTouched(setNestedObjectValues(errors, true));
    }
  }, [validateForm, submitForm, goNextStep, setTouched]);

  return (
    <Button
      className="customer-lead-step-layout__next-button"
      type="primary"
      disabled={isSubmitting}
      loading={isSubmitting}
      onClick={handleClick}
    >
      {isLastCustomerStep ? (isCompleted ? 'Submit' : 'Save for Later') : 'Next Section'}
    </Button>
  );
}
